var map = {
	"./img/arca.jpeg": "0d62",
	"./img/archive/Union.svg": "c293",
	"./img/archive/debug.log": "b257",
	"./img/archive/ellipse_bottom.svg": "898c",
	"./img/archive/ellipse_top.svg": "04bc",
	"./img/archive/item_arrow.svg": "ef5d",
	"./img/archive/partners/partner-1.png": "cd0a",
	"./img/archive/partners/partner-2.png": "67b6",
	"./img/archive/partners/partner-3.png": "d5f4",
	"./img/archive/partners/partner-4.png": "c836",
	"./img/archive/partners/partner-5.png": "fccb",
	"./img/archive/partners/partner-6.png": "c514",
	"./img/archive/partners/partner-7.png": "729e",
	"./img/archive/partners/partner-8.png": "387a",
	"./img/bed1.svg": "4e01",
	"./img/bed2.svg": "e86e",
	"./img/children-program/cp-1.jpg": "fc7b",
	"./img/children-program/cp-2.jpg": "8a2c",
	"./img/children-program/tc-1.png": "1acc",
	"./img/confirmation_bg.jpg": "d5cd",
	"./img/evening-prgoram/ep-1.jpeg": "5006",
	"./img/evening-prgoram/ep-10.jpg": "6e06",
	"./img/evening-prgoram/ep-2.jpg": "5b6a",
	"./img/evening-prgoram/ep-3.jpg": "ada7",
	"./img/evening-prgoram/ep-4.jpg": "f415",
	"./img/evening-prgoram/ep-5.jpg": "9215",
	"./img/evening-prgoram/ep-6.jpeg": "5297",
	"./img/evening-prgoram/ep-7.png": "f9e4",
	"./img/evening-prgoram/ep-8.jpg": "87b4",
	"./img/evening-prgoram/ep-9.jpeg": "2454",
	"./img/events/event-surprising-facts-armenia.webp": "f79f",
	"./img/lectures2023/speaker_1.jpg": "6222",
	"./img/lectures2023/speaker_10.jpg": "c3ef",
	"./img/lectures2023/speaker_11.jpeg": "ff6c",
	"./img/lectures2023/speaker_12.jpg": "9d21",
	"./img/lectures2023/speaker_13.jpg": "59d2",
	"./img/lectures2023/speaker_14.jpg": "c4fa",
	"./img/lectures2023/speaker_15.jpg": "fdf8",
	"./img/lectures2023/speaker_16.jpg": "f62d",
	"./img/lectures2023/speaker_17.jpg": "dc46",
	"./img/lectures2023/speaker_18.jpg": "8f88",
	"./img/lectures2023/speaker_19.jpg": "e25d",
	"./img/lectures2023/speaker_2.jpg": "5073",
	"./img/lectures2023/speaker_20.jpg": "253d",
	"./img/lectures2023/speaker_21.jpg": "e874",
	"./img/lectures2023/speaker_22.jpg": "08ce",
	"./img/lectures2023/speaker_23.jpg": "7bb1",
	"./img/lectures2023/speaker_24.jpg": "f1cc",
	"./img/lectures2023/speaker_25.jpg": "ac55",
	"./img/lectures2023/speaker_3.jpg": "196a",
	"./img/lectures2023/speaker_4.jpg": "e323",
	"./img/lectures2023/speaker_5.jpg": "4a98",
	"./img/lectures2023/speaker_6.jpg": "e371",
	"./img/lectures2023/speaker_7.jpg": "2697",
	"./img/lectures2023/speaker_8.jpg": "f110",
	"./img/lectures2023/speaker_9.jpeg": "e3e5",
	"./img/lectures2024/speaker_1.jpg": "dada",
	"./img/lectures2024/speaker_10.jpg": "c9b6",
	"./img/lectures2024/speaker_11.jpg": "6626",
	"./img/lectures2024/speaker_12.jpg": "62a1",
	"./img/lectures2024/speaker_13.jpg": "4404",
	"./img/lectures2024/speaker_14.jpeg": "932d",
	"./img/lectures2024/speaker_15.jpg": "c692",
	"./img/lectures2024/speaker_16.jpg": "c78b",
	"./img/lectures2024/speaker_17.jpg": "5668",
	"./img/lectures2024/speaker_18.jpg": "6751",
	"./img/lectures2024/speaker_19.jpg": "754b",
	"./img/lectures2024/speaker_2.jpg": "a235",
	"./img/lectures2024/speaker_20.jpg": "deec",
	"./img/lectures2024/speaker_21.jpg": "1e6d",
	"./img/lectures2024/speaker_22.jpg": "40ec",
	"./img/lectures2024/speaker_23.jpg": "99a9",
	"./img/lectures2024/speaker_24.jpg": "8b83",
	"./img/lectures2024/speaker_25.jpg": "ef2f",
	"./img/lectures2024/speaker_26.jpg": "7342",
	"./img/lectures2024/speaker_27.jpg": "647e",
	"./img/lectures2024/speaker_28.jpg": "d797",
	"./img/lectures2024/speaker_29.jpg": "7d31",
	"./img/lectures2024/speaker_3.jpg": "7ad2",
	"./img/lectures2024/speaker_30.jpg": "3ba4",
	"./img/lectures2024/speaker_31.jpg": "c363",
	"./img/lectures2024/speaker_32.jpg": "72e4",
	"./img/lectures2024/speaker_33.jpg": "2336",
	"./img/lectures2024/speaker_5.jpg": "b04c",
	"./img/lectures2024/speaker_6.jpg": "9811",
	"./img/lectures2024/speaker_7.jpg": "9c9d",
	"./img/lectures2024/speaker_8.jpg": "b969",
	"./img/lectures2024/speaker_9.jpeg": "6e02",
	"./img/lectures2025/speaker_1.jpg": "8a8d",
	"./img/lectures2025/speaker_10.jpg": "edb8",
	"./img/lectures2025/speaker_11.jpg": "ddb8",
	"./img/lectures2025/speaker_12.jpg": "248d",
	"./img/lectures2025/speaker_13.jpg": "31cd",
	"./img/lectures2025/speaker_14.jpg": "abfa",
	"./img/lectures2025/speaker_15.jpg": "9573",
	"./img/lectures2025/speaker_16.jpg": "ed43",
	"./img/lectures2025/speaker_17.jpg": "543d",
	"./img/lectures2025/speaker_18.jpg": "91d7",
	"./img/lectures2025/speaker_19.jpg": "8e32",
	"./img/lectures2025/speaker_2.jpg": "9d18",
	"./img/lectures2025/speaker_20.jpg": "ade7",
	"./img/lectures2025/speaker_21.jpg": "8b37",
	"./img/lectures2025/speaker_3.jpg": "8b75",
	"./img/lectures2025/speaker_5.jpg": "ea86",
	"./img/lectures2025/speaker_6.jpg": "bf7f",
	"./img/lectures2025/speaker_7.jpg": "30fa",
	"./img/lectures2025/speaker_8.jpg": "a190",
	"./img/lectures2025/speaker_9.jpeg": "3ed6",
	"./img/lectures2025/speaker_9.jpg": "4fc7",
	"./img/map.png": "48dd",
	"./img/mastercard.png": "ff57",
	"./img/partners/partner10.jpg": "4d66",
	"./img/partners/partner11.jpg": "0f31",
	"./img/partners/partner12.png": "c1a5",
	"./img/partners/partner13.png": "093e",
	"./img/partners/partner14.png": "ae18",
	"./img/partners/partner15.jpg": "6f2c",
	"./img/partners/partner16.jpg": "c350",
	"./img/partners/partner17.jpg": "b57e",
	"./img/partners/partner18.jpg": "ef4a",
	"./img/partners/partner3.png": "d87c",
	"./img/partners/partner4.png": "7bbe",
	"./img/partners/partner4.svg": "9096",
	"./img/partners/partner5.jpg": "7b36",
	"./img/partners/partner6.png": "d718d",
	"./img/partners/partner7.png": "d8c3",
	"./img/partners/partner8.png": "6896",
	"./img/partners/partner9.jpg": "41e5",
	"./img/partners/partner9_arm.jpg": "a91c",
	"./img/partners/partner9_ru.jpg": "49f2",
	"./img/payment/mir_logo.png": "5fec",
	"./img/payment/wallet.svg": "6377",
	"./img/slides/slide_1.jpg": "a2c1",
	"./img/slides/slide_2.jpg": "706e",
	"./img/slides/slide_2.webp": "ee57",
	"./img/slides/slide_3.jpg": "2dc1",
	"./img/slides/slide_4.jpg": "bec4",
	"./img/slides/slide_4.webp": "e6ab",
	"./img/slides/slide_5.jpg": "340e",
	"./img/slides/slide_5.webp": "de3b",
	"./img/slides/slide_6.webp": "f03b",
	"./img/slides/slide_7.webp": "69de",
	"./img/slides/slide_8.webp": "6438",
	"./img/slides/slide_9.webp": "6f2d",
	"./img/transfer_map.jpg": "2b5d",
	"./img/visa.png": "073b",
	"./img/volunteers/v0.png": "e20f",
	"./img/volunteers/v1.png": "b785",
	"./img/volunteers/v2.png": "9f0b",
	"./img/volunteers/v3.png": "0938"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "72b0";